import { AppRoutes } from './AppRoutes';
import { useDialogPointerLockGuard } from './hooks/use-dialog-pointer-lock-guard';

export default function App() {
  useDialogPointerLockGuard();
  return <AppRoutes />;
}
